export default function formatData(obj) {
  let res = { ...obj }
  for (const i in obj) {
    if (Object.prototype.toString.call(obj[i]) === '[object Object]') {
      res = { ...res, ...obj[i] }
    }
  }
  return res
}
